const createMessageSignerApi = ({ messageSigner }) => ({
    messageSigner: {
        signMessage: (params) => messageSigner.signMessage(params),
    },
});
const messageSignerApiDefinition = {
    id: 'messageSignerApi',
    type: 'api',
    factory: createMessageSignerApi,
    dependencies: ['messageSigner'],
};
export default messageSignerApiDefinition;
